// @flow

export type PhoneLinesActionType =
  | {|
      type: 'TOGGLE_PHONE_LINES_EDITING',
    |}
  | {|
      type: 'FETCH_PHONE_LINES_SUCCESS',
      payload: {| phoneLines: Object[] |},
    |}
  | {|
      type: 'RESET_PHONE_LINES',
    |}
  | {|
      type: 'UPDATE_PHONE_LINES',
    |}
  | {|
      type: 'UPDATE_PHONE_LINE_ALIAS',
      payload: {| alias: string, number: string |},
    |}
  | {|
      type: 'SET_PHONE_LINES',
      payload: {| updatedPhoneLines: Object[] |},
    |};

export const togglePhoneLinesEditing = (): PhoneLinesActionType => ({ type: 'TOGGLE_PHONE_LINES_EDITING' });

export const updatePhoneLineAlias = (number: string, alias: string): PhoneLinesActionType => ({
  payload: { alias, number },
  type: 'UPDATE_PHONE_LINE_ALIAS',
});

export const updatePhoneLines = (): PhoneLinesActionType => ({
  type: 'UPDATE_PHONE_LINES',
});

export const setPhoneLines = (updatedPhoneLines: Object[]): PhoneLinesActionType => ({
  type: 'SET_PHONE_LINES',
  payload: { updatedPhoneLines },
});

export const resetPhoneLines = (): PhoneLinesActionType => ({
  type: 'RESET_PHONE_LINES',
});

export const fetchPhoneLinesSuccess = (phoneLines: Object[]): PhoneLinesActionType => ({
  type: 'FETCH_PHONE_LINES_SUCCESS',
  payload: { phoneLines },
});
